import Radio from '../../field/Radio'
import withState from '../../withState'

export default withState()(Radio)
